const Settings = require('./domain/settings'),
	adManager = require('./services/adManager'),
	breakpoints = require('../services/breakpoints'),
	messaging = require('./services/messaging'),
	sizeMappings = require('../services/sizeMappings'),
	slotManager = require('./services/slotManager'),
	refreshManager = require('./services/refreshManager'),
	hooks = require('../utils/hooks'),
	cmd = require('../utils/cmd'),
	pubsub = require('../utils/pubsub'),
	lazyLoadService = require('../services/lazyLoadService'),
	closeableAdManager = require('../services/closeableAdManager');

require('../utils/debug');

if (window.advert && typeof window.advert.init === 'function') {
	throw new Error('[ADVERT] web advertising script already loaded');
}

async function init(config, userHooks) {
	cmd.reject('loaded');

	const {
		'dfp': dfpConfig
	} = config;

	_coreInit(userHooks);

	await _dfpInit(dfpConfig);

	cmd.accept('loaded');
}

function _coreInit(userHooks = {}) {
	performance.mark('advert - core - initialisation - start');

	hooks.init(userHooks);
	window.advert.addHook = hooks.add;
	window.advert.removeHook = hooks.remove;

	performance.mark('advert - core - initialisation - end');
}

async function _dfpInit(config) {
	performance.mark('advert - dfp - initialisation - start');

	const settings = new Settings(config);

	messaging.init();
	breakpoints.init(settings);
	sizeMappings.init(settings);
	refreshManager.init(settings);
	await lazyLoadService.init(settings);
	await adManager.init(settings);
	await slotManager.init(settings);
	await closeableAdManager.init(slotManager);

	performance.mark('advert - dfp - initialisation - end');
}

const initialCmds = window.advert && window.advert.cmd || [];

window.advert = Object.assign({}, window.advert, {
	init,
	pubsub,
	cmd,
	'loadSlot': slotManager.loadSlot,
	'getSlot': slotManager.getSlot,
	'getSlots': slotManager.getSlots,
	'defineSlots': slotManager.defineSlots,
	'getCurrentBreakpoint': breakpoints.getCurrentBreakpoint,
	'getSizeMapping': sizeMappings.getSizeMapping
});

cmd.setup(initialCmds, ['ready']);
